import { FormEvent, useState } from "react";
import SpinnerLoader from "../../../../components/loader/spinner-loader";
import { SuccessFlash } from "../../../../components/helper/flash-notification";
import InputField from "../../../../components/form/input-field";
import { numberWithCommas } from "../../../../lib/helper-support";
import { useApi } from "../../../../providers/ApiProvider";

type DebitUserType = {
  user?: any;
};

const DebitUser = ({ user }: DebitUserType) => {
  const api = useApi();
  const [showModal, setShowModal] = useState<boolean>(false);

  const [amount, setAmount] = useState<string>("");
  const [amountError, setAmountError] = useState<string | null>(null);

  const [narration, setNarration] = useState<string>("");

  const submitForm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setAmountError(null);

    if (!amount) {
      setAmountError("Amount is required");
      return;
    }

    const request = await api.POST({
      endpoint: `users/creditDebit`,
      payload: {
        amount: amount,
        phone_number: user?.phone_number,
        type: "debit",
        narration,
      },
      refreshKeys: ["users", user.phone_number],
    });

    if (!request) return;

    SuccessFlash("User debited successfully.");

    setShowModal(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowModal(true)}
        type="button"
        className="flex items-center space-x-2 text-red-700 rounded-md border-primary hover:bg-opacity-90 input w-fit"
      >
        <span>Debit user</span>
      </button>
      {
        <div>
          <div
            className={`${showModal ? "flex" : "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}
          >
            <div className="relative w-full max-w-lg max-h-full p-4">
              <div className="relative bg-white rounded-lg shadow">
                <form onSubmit={submitForm} className="p-4 text-center md:p-5">
                  <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                    Debit user:
                  </h3>
                  <div className="grid gap-4 mb-5 text-left">
                    <InputField
                      label="Amount"
                      type="number"
                      onChangeInput={(e) => [
                        setAmount(e.target.value),
                        setAmountError(null),
                      ]}
                      error={amountError}
                    />
                    <p className="font-[400] text-[12px]">
                      {numberWithCommas(amount ?? 0)}
                    </p>
                    <InputField
                      label="Narration"
                      type="text"
                      onChangeInput={(e) => [setNarration(e.target.value)]}
                    />
                  </div>
                  <button
                    disabled={api.postLoading}
                    type="submit"
                    className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                  >
                    <span>Submit</span>
                    {api.postLoading && <SpinnerLoader />}
                  </button>
                  <button
                    disabled={api.postLoading}
                    onClick={() => setShowModal(!showModal)}
                    type="button"
                    className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 "
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div
            className={`fixed inset-0 z-40 bg-gray-900/50 ${showModal ? "" : "hidden"}`}
          ></div>
        </div>
      }
    </div>
  );
};

export default DebitUser;
